/** Port von `IwmDialogContainerDokumentUpload.razor` (`@inherits IwmDialogDokumentUpload`). */

import { useCallback } from 'react';

import type { Document } from '@/types/entities';

import { DocumentUploadDialog } from './DocumentUploadDialog';
import { useContainerMatchcode } from './matchcode';

export interface ContainerDocumentUploadDialogProps {
  open: boolean;
  onClose: () => void;
  viewId: number;
  containerId: number;
  onSuccess?: () => void;
}

export function ContainerDocumentUploadDialog(props: ContainerDocumentUploadDialogProps) {
  const { containerId } = props;
  const matchcode = useContainerMatchcode(props.open, props.viewId, containerId);

  // Port von `BeforeSave()`.
  const prepareModel = useCallback(
    (model: Document): Document => ({ ...model, ContainerId: containerId }),
    [containerId],
  );

  return (
    <DocumentUploadDialog
      open={props.open}
      onClose={props.onClose}
      onSuccess={props.onSuccess}
      matchcode={matchcode}
      prepareModel={prepareModel}
    />
  );
}

export default ContainerDocumentUploadDialog;
